export const PHOTOBOOTH_ANALYTICS_EVENTS = {
  opened: "photobooth opened",
  photoSaved: "photobooth photo saved"
} as const;

export type PhotoboothAnalyticsSource = "photobooth_page" | "person_avatar" | "admin_tools";

export type PhotoboothCaptureMethod = "camera" | "upload";

export type PhotoboothAnalyticsData = {
  pgaId?: string;
  source: PhotoboothAnalyticsSource;
  mode?: "upload" | "camera";
  captureMethod?: PhotoboothCaptureMethod;
  success: boolean;
};

export function getPhotoboothOpenedAnalyticsData({
  pgaId,
  source,
  mode
}: {
  pgaId?: string;
  source: PhotoboothAnalyticsSource;
  mode?: "upload" | "camera";
}): PhotoboothAnalyticsData {
  return {
    ...(pgaId ? { pgaId } : {}),
    source,
    ...(mode ? { mode } : {}),
    success: true
  };
}

export function getPhotoboothPhotoSavedAnalyticsData({
  pgaId,
  source,
  captureMethod
}: {
  pgaId: string;
  source: PhotoboothAnalyticsSource;
  captureMethod?: PhotoboothCaptureMethod;
}): PhotoboothAnalyticsData {
  return {
    pgaId,
    source,
    ...(captureMethod ? { captureMethod } : {}),
    success: true
  };
}
